module.exports = __webpack_public_path__ + "static/media/aulas-essenciais.f3d18dfa.jpg";